import { render, staticRenderFns } from "./ToolFetch.vue?vue&type=template&id=74ea5569&"
import script from "./ToolFetch.vue?vue&type=script&lang=js&"
export * from "./ToolFetch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports